import { useState } from "react";

type SelectedKey =
  | "/img/overviewsection/manufacturing_facility_circle.png"
  | "/img/overviewsection/research_and_development_circle.png"
  | "custom_circle";

const data: Record<
  SelectedKey,
  { title: string; description: string; rightImage: string }
> = {
  "/img/overviewsection/manufacturing_facility_circle.png": {
    title: "Manufacturing Facility",
    description: `Our zero-discharge, zero-emission manufacturing facility in India is designed with sustainability and precision at its core. The facility features dedicated fermentation trains for each product class, supported by advanced PLC and SCADA systems for full process control and monitoring. With both solid-state and submerged fermentation capabilities, we ensure optimal conditions for consistent product quality.`,
    rightImage: "/img/overviewsection/manufacturing_facility.png",
  },
  "/img/overviewsection/research_and_development_circle.png": {
    title: "Research & Development",
    description: `We are committed to persistent research and innovation, a core part of our mission. Our independent in-house R&D center, supported by a pilot plant, is equipped to handle diverse probiotics and biotech molecules. A team of experienced microbiology and biotechnology professionals, along with external experts, drives our efforts. 
    
    Our focus spans strain discovery, characterization, host response studies, and formulation improvements to enhance product performance and delivery. We continuously work on process optimization, yield enhancement, and exploring new applications for probiotics, including synergies with natural and synthetic ingredients.
  
    Beyond probiotics, we are advancing into next-generation biotech products such as nutraceuticals, biotherapeutics, and peptides—transforming research into scalable solutions aligned with our vision for sustainable animal health.`,
    rightImage: "/img/overviewsection/research_and_development.png",
  },
  "custom_circle": {
    title: "Custom Section",
    description: "This is a custom section description.",
    rightImage: "/img/overviewsection/custom_image.png",
  },
};

const ResearchDetails = () => {
  const [selected, setSelected] = useState<SelectedKey>(
    "/img/overviewsection/research_and_development_circle.png"
  );

  const handleSelect = (imgSrc: SelectedKey) => {
    setSelected(imgSrc);
  };

  return (
    <section className="flex flex-col lg:flex-row w-full min-h-screen relative">
      {/* LEFT IMAGE */}
      <div className="relative w-full lg:w-[48%] h-[250px] sm:h-[350px] lg:h-auto">
        <img
          src={data[selected].rightImage}
          alt={data[selected].title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* RIGHT CONTENT */}
      <div className="relative w-full lg:w-[52%] bg-[#1c2c38] text-white flex flex-col justify-center px-6 sm:px-10 lg:px-20 py-10 sm:py-12">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-6">
          {data[selected].title}
        </h2>
        <p className="text-gray-200 leading-relaxed mb-6 whitespace-pre-line">
          {data[selected].description}
        </p>
      </div>

      {/* FLOATING CIRCLE (visible only lg+) */}
      <div className="hidden lg:block absolute bottom-7 right-7 float-animation">
        <div
          onClick={() => handleSelect("custom_circle")}
          className="w-20 h-20 lg:w-28 lg:h-28 rounded-full cursor-pointer"
          style={{ backgroundColor: "rgba(232, 82, 34, 1)" }}
        />
      </div>
    </section>
  );
};

export default ResearchDetails;
